var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke no-fill"},[_c('path',{attrs:{"d":"M7.5 24L19.5 12.5L7.5 1","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }